module.exports = __webpack_public_path__ + "img/Mapna-gray.0ba431c.png";